// extracted by mini-css-extract-plugin
export default {"Container":"styles_Container__yUZI8","line":"styles_line__MRHVF","baloonContainer":"styles_baloonContainer__SPZ9p","baloonDescription":"styles_baloonDescription__vEVk3"};